import React, {useEffect, useState} from 'react';
import { Table } from 'antd';
import {Redirect} from "react-router-dom";


const RoomsTable = ({imba_id, dataSource, columns}) => {
    const[loading, setLoading] = useState(true)
    const [choose, setChoose] = useState(false)

    useEffect(() => {
        //setLoading(false)
        if (dataSource)
            setLoading(false);
    }, [dataSource])
    return  choose ? (
        <Redirect to = {{ pathname: `/${imba_id}/room/${choose}` }} />
    ) : (
        <Table columns={columns} pagination={false} dataSource={dataSource} loading={loading} rowClassName={'imbachat-table-row'}
               onRow={
                   (record, index) => {
                       return {
                           onClick: event => {
                                console.log('event.target',event.target)
                                console.log('event.target',event.target.id.includes('rc_select'))
                                if(event.target.outerText != "ban room" && !event.target.id.includes('rc_select') && !(event.target.outerText == "1h" || event.target.outerText == "30m" || event.target.outerText == "24h" || event.target.outerText == "1 week" || event.target.outerText == "forever") && event.target.outerText != "OK"){
                                    setChoose(record.id)
                                }
                               //setChoose(record.id)
                           }
                       }
                   }
               }/>
    )
}
export default RoomsTable;